

/**
*========================================
*	
*	Sizing / Spacing Script
*	
*========================================
*/

(function($) {
    

    $(document).on('ready', () => {

        // Start
        setTimeout(() => {
            sizingSpacing();
        }, 100);

        $(window).on('resize', sizingSpacing);


        /**
        *========================================
        *	
        *	Images
        *	
        *========================================
        */

        function sizingSpacing() {


            window.headerHeight = document.querySelector('.sci-navigation').offsetHeight;
    
            $('.sci-image, iframe').each( function () {
                let width = $(this).width();
                $(this).css('height', width / 1.6);

                if($(this).parents('.sci-tile').length != 0) {
                    // $(this).css('height', width / 3.2);
                }
            })

            const paddingTop = (window.salemoche.currentBreakpoint == 'small' || window.salemoche.currentBreakpoint == 'medium') ? '16px' : window.headerHeight + 32 + 'px' ;
            // const paddingTop = (window.salemoche.currentBreakpoint == 'small' || window.salemoche.currentBreakpoint == 'medium') ? '32px' : '32px' ;
    
            $('.sci-content:not(.sci-home)').css('padding-top', paddingTop);
            // console.log(paddingTop)
            $('.sci-intro').css('min-height', window.innerHeight - window.headerHeight + 'px');
            $('.sci-intro').css('padding-top', `${window.headerHeight}px` );
            $('.sci-detail-header-placeholder, .sci-intro-image-placeholder').css('min-height', window.innerHeight * 0.66 - window.headerHeight + 'px');

            $('.sci-404').css('padding-bottom', window.headerHeight + 32 + 'px');
            $('.sci-404 .sci-intro').css('min-height', window.innerHeight - (window.headerHeight * 2) + 'px');


            // Impression Caption

            $('.sci-impressions__image').each( function() {
                const that = $(this);
                const thatHeight = that.height();
                const caption = that.find('.sci-impressions__image__caption');
                const captionHeight = caption.height();
                const image = that.find('img, a');
                const imageHeight = image.height();
                
                image.css('height', thatHeight);

                if (caption.length != 0) {
                    that.css('height', thatHeight + captionHeight + 16);
                }

                // console.log(thatHeight, captionHeight)
            })

            // Icons
            // Favorite
            $('.simplefavorite-button').css('left', $('.sci-detail-header__content__favorite__text').width() + 12 + 'px')
        }
        
    })

})(jQuery)